document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const menu = document.querySelector('[data-mobile-menu]');
      if (!menu) return;
      const isOpen = menu.hasAttribute('hidden');
      menu.toggleAttribute('hidden');
      button.setAttribute('aria-expanded', String(isOpen));
      document.body.classList.toggle('menu-open', isOpen);
    });
  });

  document.querySelectorAll('[data-close-menu]').forEach((button) => {
    button.addEventListener('click', () => {
      const menu = document.querySelector('[data-mobile-menu]');
      if (!menu) return;
      menu.setAttribute('hidden', '');
      document.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('menu-open');
    });
  });

  document.querySelectorAll('[data-product-select]').forEach((select) => {
    select.addEventListener('change', (event) => {
      const selected = event.target.options[event.target.selectedIndex];
      const price = event.target.closest('[data-product-form]')?.querySelector('[data-price]');
      if (price && selected.dataset.price) price.textContent = selected.dataset.price;
    });
  });
});
